import { httpClient } from "util/Api";
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';

// 上传 Complaint Document（打开文档上传弹窗）
export function uploadReport({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'Document');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'ComplaintDocument', complaintId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('JobDocumentFolderId', 0);
  }, config.setTimeoutMilliSecond);
}

// 删除 Complaint Document
export function deleteComplaintDocument({ parameter, sections, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .post('/Business/Complaint/DeleteComplaintDocument/', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
